import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import './Waitlist.css';

const PaymentRequired = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/profile?tab=account&onboarding=1', { replace: true });
    }, [navigate]);

    return (
        <div className="waitlist-container">
            <div className="waitlist-content">
                <Logo size={80} />
                <h1 style={{ marginTop: '30px' }}>Payment Method Required</h1>
                <p style={{ fontSize: '1.2rem', color: '#666', marginBottom: '30px', maxWidth: '520px' }}>
                    Your KeyFlo account is approved. Complete your profile and add a valid card to start your free trial and access the portal.
                </p>
                <p style={{ color: '#64748b' }}>Redirecting to profile…</p>
            </div>
        </div>
    );
};

export default PaymentRequired;
